import React from 'react';
import './IceCreamList.css';
import '../Novelties/NoveltiesList.css'; // Reuse the same card/grid styles

const iceCreams = [
  { name: 'Alphonso Mango', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/AlphonsoMangoFInal.jpg' },
  { name: 'Black Current', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/BlackCurrent.jpg' },
  { name: 'Blue Mango', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/Blue MangoFInal+MLI.jpg' },
  { name: 'Blueberry Cheesecake', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/Blueberrycheesecake.jpg' },
  { name: 'Butter Pecan', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/ButterPecan.jpg' },
  { name: 'Butterscotch', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/Butterscotch.jpg' },
  { name: 'Cashew Raisin', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/CashewRaisin.jpg' },
  { name: 'Chickoo', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/Chickoo.jpg' },
  { name: 'Choc Chip Cookie Dough', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/ChocChipCookieDough.jpg' },
  { name: 'Chocolate', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/Chocolate_1.jpg' },
  { name: 'Chunkey Monkey', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/ChunkeyMonkey.jpg' },
  { name: 'Cookies and Creme', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/CookiesnCreme.jpg' },
  { name: 'English Toffee', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/EnglishToffee.jpg' },
  { name: 'Ferrero Rocher', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/FerreroRocher.jpg' },
  { name: 'Guava', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/Guava.jpg' },
  { name: 'Kesar Pista', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/KesarPista.jpg' },
  { name: 'Kulfi Falooda', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/KulfiFalooda.jpg' },
  { name: 'Lychee', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/Lychee.jpg' },
  { name: 'Malai Kulfi', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/MalaiKulfi.jpg' },
  { name: 'Meetha Paan', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/MeethaPaan.jpg' },
  { name: 'Nuttie Tutti', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/NuttieTuttie Fruitee.jpg' },
  { name: 'Orange Pineapple', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/OrangePineapple.jpg' },
  { name: 'Pistachio', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/Pistachio.jpg' },
  { name: 'Rajbhog', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/Rajbhog.jpg' },
  { name: 'Rose Petals', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/RosePetals.jpg' },
  { name: 'Rum Raisin', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/RumRaisin.jpg' },
  { name: 'Sea Salt Caramel', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/SeaSaltCaramel.jpg' },
  { name: 'Sitafal', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/Sitafal.jpg' },
  { name: 'Starwberry', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/Starwberry.jpg' },
  { name: 'Thandai', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/Thandai.jpg' },
  { name: 'Tiramisu', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/Tiramisu.jpg' },
  { name: 'Vanilla', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/Vanilla.jpg' },
  { name: 'Walnut Figs', image: process.env.PUBLIC_URL + '/assets/nv/icecreamimage/WalnutFigs.jpg' },
];

const IceCreamList = () => {
  return (
    <section className="novelties-list section">
      <div className="container">
        <div className="novelties-grid">
          {iceCreams.map((ice, idx) => (
            <div className="novelty-card" key={idx}>
                <img
                  src={ice.image}
                  alt={ice.name}
                  className="novelty-img"
                />
                <div className="novelty-name">{ice.name}</div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default IceCreamList; 